import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import "./styles.scss";
import { generateImageLogo } from "../../api";
import { MdCached } from "react-icons/md";

const LogoViewer = () => {
    const { formatMessage } = useIntl();
    const [setError] = useState(false);
    const [altText, setAltText] = useState("");
    const [urlImage, setUrlImage] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchLogoPjUser = async () => {
            await generateImageLogo()
                .then(res => {
                    setUrlImage(res.data.Location);
                    setAltText(res.data.altText);
                })
                .catch(() => setError(formatMessage({ id: "erro-api" })))
                .finally(() => setIsLoading(false));
        };

        fetchLogoPjUser();
    }, [setError, formatMessage]);

    return (
        <>
            <div className="operation-header">
                {isLoading ? (
                    <MdCached className="loader-only-rotation" size={16} />
                ) :
                    (
                        <img className="large-logo" src={urlImage} alt={altText} />
                    )}
            </div>
        </>
    );
};

export default LogoViewer;